import getEquipmentFiltersExercisesUiSelect from '../../../../exercises-ui/selectors/get-equipment-filters'
import getMusclesFiltersExercisesSelect from '../../../../exercises-ui/selectors/get-muscles-filters'
import getQueryExercisesSelect from '../../../../exercises-ui/selectors/get-query'
import getTypesFiltersExercisesUiSelector from '../../../../exercises-ui/selectors/get-types-filters'
import getDomainMapExercisesSelect from '../get-domain-map'
import getIdsByMuscleExerciseSelector from '../get-ids-by-muscle'
import { PAGINATION_LIMIT_DEFAULT } from '../../../../redux/constants/query-params'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getItemsCountFromPageReduxUtil } from '../../../../redux/utils/get-page'
import { createSelector } from 'reselect'
import {
  EXERCISE_TYPE,
  getEquipmentExerciseUtil,
  getTypeExerciseUtil
} from '../../../model'
import { getPageExerciseUiSelect } from '../../../../exercises-ui'
import { performSearchUtil } from 'packages/src'

function getMusclesFilteredExercisesSelector (muscleFiltersParams) {
  return createSelector(getMusclesFiltersExercisesSelect,
    getDomainMapExercisesSelect,
    getIdsByMuscleExerciseSelector(),
    (musclesFilters, data, muscleToIds) => {
      musclesFilters = muscleFiltersParams || musclesFilters
      if (!musclesFilters?.length) {
        return Object.values(data)
      }

      return musclesFilters.reduce((arr, muscle) => {
        const domainList = muscleToIds[muscle]
        if (!domainList) {
          return arr
        }
        const ids = domainList.data || []
        arr = [
          ...arr,
          ...ids.map(id => data[id])
        ]
        return arr
      }, [])
    }
  )
}

function getTypesFilteredExercises (exercises, typesFilters) {
  return exercises.filter(exercise => {
    return typesFilters.includes(getTypeExerciseUtil(exercise))
  })
}

function getEquipmentFilteredExercises (exercises, equipmentFilters) {
  return exercises.filter(exercise => {
    return !!(
      equipmentFilters.find(eq => getEquipmentExerciseUtil(exercise)
        .includes(eq))
    )
  })
}

function getFoundExercisesSelector (params = {}) {
  return createSelector(getQueryExercisesSelect,
    getMusclesFilteredExercisesSelector(params.muscleFilters),
    getTypesFiltersExercisesUiSelector,
    getEquipmentFiltersExercisesUiSelect,
    getPageExerciseUiSelect,
    (query, exercises, typesFiltersParams, equipmentFiltersParams, page) => {
      const equipmentFilters = params.equipmentFilters || equipmentFiltersParams
      const typesFilters = params.typesFilters || typesFiltersParams
      if (params?.shouldFilterActivities) {
        exercises = exercises.filter(ex => getTypeExerciseUtil(ex) !==
          EXERCISE_TYPE.ACTIVITY)
      }
      if (typesFilters?.length) {
        exercises = getTypesFilteredExercises(exercises, typesFilters)
      }
      if (equipmentFilters?.length) {
        exercises = getEquipmentFilteredExercises(exercises, equipmentFilters)
      }

      // TODO domain list per page
      const itemsCountPerPage = (
        getItemsCountFromPageReduxUtil(page, PAGINATION_LIMIT_DEFAULT)
      )

      const itemsCountToGet = params.ignorePagination
        ? -1
        : itemsCountPerPage

      if (!query) {
        return exercises
          .slice(0, itemsCountToGet)
          .map(getIdReduxUtil)
      }
      return performSearchUtil(exercises, query)
        .slice(0, itemsCountToGet)
        .map(getIdReduxUtil)
    }
  )
}

export const getExercisesCountExerciseSelect = state => {
  const items = getFoundExercisesSelector()(state)
  return items.length
}
export const getTotalExercisesCountExerciseSelect = state => {
  const items = getFoundExercisesSelector({
    ignorePagination: true
  })(state)
  return items.length
}

export const getPaginationLimitExerciseUtil = () => {
  return PAGINATION_LIMIT_DEFAULT
}

export default getFoundExercisesSelector
